/** 確認日期是否為有效 (轉換失敗時Date物件為Invalid Date，輸出時間為NaN) */
export const isInvalid = (d: Date): boolean =>
  d instanceof Date && !isNaN(d.getTime());
